/**
 * Default `allow` (Permissions Policy) for parent pages that embed ACH / content-studio
 * via `<iframe>`. Without this, features like `getUserMedia` (microphone) are denied
 * even when the user would grant permission.
 *
 * `*` in the allow-list permits the capability for origins in the embedded document
 * (see HTML `iframe` `allow` attribute).
 */
export const ACH_EMBED_IFRAME_ALLOW = [
    'accelerometer *',
    'autoplay *',
    'camera *',
    'clipboard-read *',
    'clipboard-write *',
    'display-capture *',
    'encrypted-media *',
    'fullscreen *',
    'gamepad *',
    'geolocation *',
    'gyroscope *',
    'magnetometer *',
    'microphone *',
    'midi *',
    'payment *',
    'picture-in-picture *',
    'publickey-credentials-get *',
    'screen-wake-lock *',
    'speaker-selection *',
    'usb *',
    'web-share *',
    'xr-spatial-tracking *',
].join('; ');
